import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import VueJsonp from 'vue-jsonp'
import '@/styles/index.scss' // global css
import 'v-charts/lib/style.css'

import App from './App'
import router from './router'
import store from './store'

import VueCountUp from 'vue-countupjs'

import '@/icons' // icon
import '@/permission' // permission control
Vue.use(VueJsonp)
Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.use(VueCountUp)
import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.min.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'
import '../static/UE/themes/default/css/ueditor.css'


import auths from './auths'
// 判断用户的权限， 返回true代表有权限
Vue.prototype.roleCode = localStorage.getItem('roleCode')
export const updateRoleCode = function(){
    Vue.prototype.roleCode = localStorage.getItem('roleCode')
}


Vue.prototype.isAuth = function(auth) {
    let roleCode = localStorage.getItem('roleCode');
    if (!auth) return true;  // 如果auth参数是空， 默认为拥有权限
    if (roleCode === 'ADMIN' || roleCode === 'STE') return true;    // 超级管理员 和 测试人员 拥有全部权限
    let isExist = auths[roleCode].indexOf(auth);   // 等于 -1 则无权限（返回-1说明该权限枚举不在权限数组中）
    return isExist !== -1;
};

Vue.prototype.thisMonth = function () {
    let myDate = new Date();
    let thisyear = myDate.getYear() + 1900;
    let thismonth = myDate.getMonth() + 1;
    return new Date(thisyear + "-" + thismonth + "-01 00:00:00").getTime()
}

Vue.prototype.thisDay = function () {
    let myDate = new Date();
    let thisyear = myDate.getYear() + 1900;
    let thismonth = myDate.getMonth() + 1;
    let thisDate = myDate.getDate()
    return new Date(thisyear + "-" + thismonth + "-" + thisDate + " 23:59:59").getTime()
}

import SelectAgentForm from '@/components/selectAgentForm'
Vue.component('SelectAgentForm', SelectAgentForm)

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js